import { Button, ButtonProps } from "@mezo-org/mezo-clay"

export default function StepperModalButton(props: ButtonProps) {
  return <Button size="large" width="100%" {...props} />
}
